<button
    class="kk-btn kk-btn_secondary filter-button"
    [ngClass]="{ 'filter-active': this.active }"
    (click)="onActivationEvent()"
>
    <span>
        <ng-content></ng-content>
    </span>
    <app-svg-icon iconName="plus"></app-svg-icon>
</button>
